import React, { useEffect, useState } from "react";
import styles from "./ServicesSection.module.css";
import Card from "../../Card/Card";
import { FaTerminal } from "react-icons/fa6";
import RowCard from "../../Card/RowCard";
import { useNavigate } from "react-router-dom";
import { isSmallScreen } from "../../../utils/screen";
import { useTranslation } from "../../../hooks/useTranslation";

const ServicesSection: React.FC = () => {
  const navigate = useNavigate();
  const [isMobile, setIsMobile] = useState(false);
  const { t } = useTranslation();

  // Update the `isMobile` state based on the window size
  useEffect(() => {
    const updateIsMobile = () => {
      setIsMobile(window.innerWidth < 1240); // Adjust the breakpoint if necessary
    };

    updateIsMobile();
    window.addEventListener("resize", updateIsMobile);

    return () => {
      window.removeEventListener("resize", updateIsMobile);
    };
  }, []);

  const services = [
    {
      variant: "secondary",
      chipContent: t("services.medtech.title"),
      title: t("services.medtech.details.title"),
      subtitle: t("services.medtech.details.subtitle"),
      buttonLabel: t("services.medtech.details.button"),
      path: "/uslugi/medtech",
      hoverContent: (
        <div>
          <strong>{t("services.medtech.details.services")}</strong>
          <ul>
            <li>{t("services.medtech.details.service1")}</li>
            <li>{t("services.medtech.details.service2")}</li>
            <li>{t("services.medtech.details.service3")}</li>
          </ul>
        </div>
      ),
    },
    {
      variant: "tertiary",
      chipContent: t("services.ai.title"),
      title: t("services.ai.details.title"),
      subtitle: t("services.ai.details.subtitle"),
      buttonLabel: t("services.ai.details.button"),
      path: "/uslugi/ai",
      hoverContent: (
        <div>
          <strong>{t("services.ai.details.services")}</strong>
          <ul>
            <li>{t("services.ai.details.service1")}</li>
            <li>{t("services.ai.details.service2")}</li>
            <li>{t("services.ai.details.service3")}</li>
          </ul>
        </div>
      ),
    },
    {
      variant: "primary",
      chipContent: t("services.enterprise.title"),
      title: t("services.enterprise.details.title"),
      subtitle: t("services.enterprise.details.subtitle"),
      buttonLabel: t("services.enterprise.details.button"),
      path: "/uslugi/enterprise",
      hoverContent: (
        <div>
          <strong>{t("services.enterprise.details.services")}</strong>
          <ul>
            <li>{t("services.enterprise.details.service1")}</li>
            <li>{t("services.enterprise.details.service2")}</li>
            <li>{t("services.enterprise.details.service3")}</li>
          </ul>
        </div>
      ),
    },
  ];

  return (
    <section className={`${styles.servicesSection} servicesSection`}>
      <div className={styles.titleContainer}>
        <FaTerminal size={isSmallScreen() ? 44 : 54} />
        <div className={styles.text}>
          <h2 className={styles.sectionTitle}>{t("services.section.title")}</h2>
          <p className={styles.sectionSubtitle}>
            {t("services.section.subtitle")}
          </p>
        </div>
      </div>
      <div className={styles.cardsContainer}>
        {services.map((service, index) => (
          <Card
            key={index}
            variant={service.variant as "primary" | "secondary" | "tertiary"}
            chipContent={service.chipContent}
            title={service.title}
            subtitle={service.subtitle}
            buttonLabel={service.buttonLabel}
            onButtonClick={() => navigate(service.path)}
          />
        ))}
        {isMobile ? (<Card
          variant={"unknown"}
          chipContent={t("services.softwareAgency.title")}
          title={t("services.softwareAgency.details.title")}
          subtitle={t("services.softwareAgency.details.subtitle")}
          buttonLabel={t("services.softwareAgency.details.button")}
          onButtonClick={() => navigate("/uslugi/software-agency")}
        ></Card>) : null}
      </div>
      {!isMobile ? (<div className={styles.cardsContainer}>
        <RowCard
          chipContent={t("services.softwareAgency.title")}
          title={t("services.softwareAgency.details.title")}
          subtitle={t("services.softwareAgency.details.subtitle")}
          buttonLabel={t("services.softwareAgency.details.button")}
          onClick={() => navigate("/uslugi/software-agency")}
        />
      </div>) : null}
    </section>
  );
};

export default ServicesSection;
